import { type PathOfBlockedRecordCheaterFormType } from './types';

export const BLOCKED_RECORD_CHEATER_FORM_FIELD_NAME = {
  remark: 'remark',
} satisfies Record<string, PathOfBlockedRecordCheaterFormType>;
